import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import Coupon from '@/repositories/data/webshop/Coupon';

export default class CouponRepository extends BaseCrudRepository<number, Coupon, Coupon> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/coupon/');
    }
}
